import styled, { css } from "styled-components";
import { FaDiscord, FaGoogle } from "react-icons/fa";
import {
  SiEpicgames,
  SiFaceit,
  SiRiotgames,
  SiTiktok,
  SiBattledotnet,
} from "react-icons/si";
import { Box, Flex } from "rebass/styled-components";

import { ReactComponent as Steam } from "../../../Assets/Platforms/steam.svg";
import { ReactComponent as Badge } from "../../../Assets/Platforms/gc.svg";
import { Button } from "../../../Components/Button";

const iconStyle = css`
  position: relative;
  margin-top: ${(props) => props.theme.space[3]}px;
  margin-bottom: ${(props) => props.theme.space[3]}px;
  font-size: 25px;
  width: 25px;
  height: 25px;
`;

export const IconWrapper = styled(Box)`
  margin-right: ${(props) => props.theme.space[4]}px;
  width: 25px;
`;

// Indented past the 40px icon gutter (25px icon + space[4] margin) so it lines
// up with the read-only input above it instead of the provider icon.
export const StyledBox = styled(Flex)`
  background-color: ${(props) => props.theme.colors.ned};
  border-radius: 8px;
  margin-left: 40px;
  padding: 16px;
`;

export const StyledBody = styled(Box)`
  color: ${({ theme }) => theme.colors.ice};
`;

const StyledNote = styled(Box)`
  color: ${({ theme }) => theme.colors.chalkAlpha80};
`;

const StyledSpan = styled(StyledBody)`
  color: ${(props) => props.theme.colors.error};
`;

export const StyledDiscordIcon = styled(FaDiscord)`
  ${iconStyle}
  color: ${({ theme }) => theme.colors.discord};
`;

export const StyledGoogleIcon = styled(FaGoogle)`
  ${iconStyle}
  color: ${({ theme }) => theme.colors.ice};
`;

export const SharecodeButton = styled(Button)`
  align-items: center;
  border-radius: 8px;
  display: flex;
  font-size: ${({ theme }) => theme.text.subheader.fontSize};
  justify-content: center;
  width: 160px;
`;

export const StyledFaceitIcon = styled(SiFaceit)`
  ${iconStyle}
  color: ${({ theme }) => theme.colors.faceit};
`;
export const StyledEpicIcon = styled(SiEpicgames)`
  ${iconStyle}
`;

export const StyledBattleNetIcon = styled(SiBattledotnet)`
  ${iconStyle}
`;

export const StyledTikTokIcon = styled(SiTiktok)`
  ${iconStyle}
  color: ${({ theme }) => theme.colors.ice};
`;

export const StyledRiot = styled(SiRiotgames)`
  ${iconStyle}
  color: ${({ theme }) => theme.colors.ice};
`;

export const StyledSteamIcon = styled(Steam)`
  ${iconStyle}
  color: ${({ theme }) => theme.colors.ice};
`;

const StyledGamersClubIcon = styled(Badge)`
  ${iconStyle}
`;

// Buttons sit beside a 3.125rem read-only input, so match that height rather
// than the 2.5rem "small" variant, and stop the flex row from squashing them.
export const UnlinkButton = styled(Button)`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: 3.125rem;
  justify-content: center;
  line-height: 1;
  width: 100px;
`;

export const DisabledButton = styled(UnlinkButton)`
  :disabled {
    cursor: not-allowed;
  }
`;

const BetaHelp = styled(Box)`
  text-decoration: underline;
  color: error;
  display: inline-block;
  margin: 0 4px;
  &:hover {
    cursor: pointer;
  }
`;

const Error = styled.div``;
const Success = styled.div``;
